import { IEmergency } from './types'

export const initialState: IEmergency = {
  emergencyMode: false,
}
